import { Localizable } from '@components/localizable/Localizable'
import { Col, Flex } from 'antd'
import Communication from '../../components/communication/Communication'
import Page from '../../components/Page/Page'

const CommunicationPage = () => {
  return (
    <Localizable>
      <Page
        pageTitle={{
          title: 'Communication toolkit',
          level: 4,
        }}
        noWrapWithCol
        rowGutter={[32, 16]}
      >
        <Col span={16}>
          <Flex vertical gap={32}>
            <Communication.DownloadLinkCard />
            <Communication.SmartBanners />
          </Flex>
        </Col>
        <Col span={8}>
          <Communication.QRCode />
        </Col>
      </Page>
    </Localizable>
  )
}

export default CommunicationPage
